module.exports = __webpack_public_path__ + "img/pic2.ce3027dd.png";